import type { TeachingPresentationSlide } from './ebook-presentation-model'
import type { TeachingPresentationStyleId } from './presentation-styles'

export type TeachingPresentationView = 'controller' | 'projector'

export interface TeachingPresentationSnapshot {
  readonly customSlides?: readonly TeachingPresentationSlide[]
  readonly currentSlideId: string | null
  readonly hiddenSlideIds: readonly string[]
  readonly orderedSlideIds: readonly string[]
  readonly showAnswer: boolean
  readonly showTranslation: boolean
  readonly styleId: TeachingPresentationStyleId
}

export type TeachingPresentationMessage =
  | {
      readonly kind: 'hello'
      readonly senderId: string
      readonly sessionId: string
    }
  | {
      readonly kind: 'snapshot'
      readonly senderId: string
      readonly sessionId: string
      readonly snapshot: TeachingPresentationSnapshot
    }
  | {
      readonly kind: 'stop'
      readonly senderId: string
      readonly sessionId: string
    }

export function createTeachingPresentationSessionId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  return `presentation-${Date.now()}-${Math.random().toString(36).slice(2)}`
}

export function createTeachingPresentationSenderId() {
  return createTeachingPresentationSessionId()
}

export function getTeachingPresentationChannelName(sessionId: string) {
  return `xinchaovietnam-teaching-presentation:${sessionId}`
}

export function createTeachingPresentationChannel(sessionId: string) {
  if (typeof window === 'undefined' || typeof BroadcastChannel === 'undefined') {
    return null
  }

  return new BroadcastChannel(getTeachingPresentationChannelName(sessionId))
}
